import { toast } from "react-toastify";

export const REQUIRED_FIELD = "Ce champ est obligatoire.";

export type FieldErrors = Record<string, string>;

export type ApiFieldError = {
    field?: string | null;
    message?: string;
};

/** Mappe `[{ field, message }]` API → `{ [field]: message }`. */
export const formatErrors = (
    errors: ApiFieldError[] | null | undefined
): FieldErrors => {
    if (!Array.isArray(errors)) return {};
    return errors.reduce<FieldErrors>((acc, curr) => {
        if (curr?.field && curr.message) {
            acc[curr.field] = curr.message;
        }
        return acc;
    }, {});
};

export const clearFieldError = (
    errors: FieldErrors,
    field: string
): FieldErrors => {
    if (!errors[field]) return errors;
    const next = { ...errors };
    delete next[field];
    return next;
};

export const setFieldErrors = (
    ...entries: Array<[string, string | undefined | false | null]>
): FieldErrors => {
    const result: FieldErrors = {};
    for (const [field, message] of entries) {
        if (message) result[field] = message;
    }
    return result;
};

/**
 * Toast + signal pour early-return. À appeler après `setFieldErrors*` :
 * l’inline reste affiché, le toast conserve le feedback global.
 * @returns true s’il y a des erreurs (il faut `return`)
 */
export const notifyFieldErrors = (
    errors: FieldErrors,
    options?: {
        /** Message toast (sinon 1re erreur inline, sinon fallback). */
        message?: string;
        type?: "error" | "warning";
    }
): boolean => {
    if (Object.keys(errors).length === 0) return false;
    const message =
        options?.message ??
        Object.values(errors)[0] ??
        "Veuillez remplir tous les champs obligatoires.";
    if (options?.type === "error") {
        toast.error(message);
    } else {
        toast.warning(message);
    }
    return true;
};
